module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABtSURBVEhL3Y3RCcAgFMQcrZt1tI7WeqBg7/yL+GHgeAQDluO42+1Q/3HVve0K6sFTp0BXUA/02CeoBx5QDzygHozBigWziGw//jv1wAPqgQfUAw+oBx5QD8ZgxYJZRLYf/5164AH1wAPqR1DKB3YiCoJnML+NAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-fence/dark/24.png
// module id = 2030
// module chunks = 2